var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrupo11391({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166.285,
    height: 39.041,
    viewBox: "0 0 166.285 39.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fe6d84;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.b{fill:#fe6d84;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.097)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3313.813,768.055l21.9-16.117,15.779,16.117,11.044-10.958,8.263,5.357,14.373-19.036,13.266,27.453,13.87-13.773,8.227,5.357,13.135-10.516,12.88,16.117,10.94-10.958,16.576-19.643",
    transform: "translate(-3313.813 -733.329)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(156.188)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo11391);
export default __webpack_public_path__ + "static/media/Grupo 1139_1.1114b82b40636f60817d2f5dab355f2e.svg";
export { ForwardRef as ReactComponent };